import { reactive } from "vue";
import Form from "form-backend-validation";
import axios from "axios";

const instance = axios.create();

class NewForm extends Form {
    constructor(data = {}, options = {}) {
        super(data, options);

        this.recentlySuccessful = false;
        this.recentlySuccessfulTimeoutId = null;
    }

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        clearTimeout(this.recentlySuccessfulTimeoutId);

        return super.submit(requestType, url);
    }

    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        this.recentlySuccessful = true;
        this.recentlySuccessfulTimeoutId = setTimeout(() => (this.recentlySuccessful = false), 2000);

        super.onSuccess(data);
    }
}

export default {
    install(app, options) {
        instance.interceptors.request.use(
            (config) => {
                // make data object
                let formData = new FormData();
                formData.set("_ajax_nonce", options.nonce);
                formData.set("action", options.prefix + config.url);
                formData.set("payload", JSON.stringify(config.data));
                config.data = formData;

                // replace url with ajax url
                config.url = options.ajaxurl;
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        instance.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                if (error.response.status !== 422) {
                    options.onError(error);
                }

                return Promise.reject(error);
            }
        );
    },
};

export const useForm = (data) => {
    const form = new NewForm(data, {
        resetOnSuccess: false,
        http: instance,
    });
    return reactive(form);
};
